/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  /* border: 1px solid #fff; */
  border-radius: 20px;

  width: 90%;

  margin: 0px auto;
  padding-top: 33px;
  /* padding-bottom: 200px; */

  @media (max-width: 1200px) {
    width: 1000px;
  }

  div.text {
    width: 40vw;
    height: 90vh;
    background-color: #fff;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;

    div.title {
      height: 30%;
      border-top-left-radius: 20px;
      padding: 20px;
    }

    div.description {
      height: 60%;
      background-color: #f0f0f0;
      padding: 20px;
      p {
        color: #000;
      }
      p.subtitle {
        color: #36ded6;
        font-size: 20px;
        font-weight: bold;
      }

      button {
        color: #36ded6;
        font-size: 16px;
        text-decoration: underline;
        border-color: rgba(0, 0, 0, 0);
        background-color: rgba(0, 0, 0, 0);
        font-weight: bold;
        margin-top: 10px;
        margin-bottom: 10px;
      }

      a {
        color: #36ded6;
        font-size: 16px;
        text-decoration: underline;
        font-weight: bold;
        margin-top: 10px;
      }
    }

    div.buttons {
      height: 10%;
      border-bottom-left-radius: 20px;
      background-color: #f0f0f0;

      display: flex;
      align-items: flex-end;

      padding: 20px;

      button.exit {
        color: #36ded6;
        font-weight: bold;
        font-size: 18px;
        text-decoration: underline;
        border-color: rgba(0, 0, 0, 0);

        margin-right: 120px;
        margin-left: -20px;
      }

      button {
        background: rgba(0, 0, 0, 0);
        border: 1px solid #333;
        border-radius: 5px;
        padding: 10px;
        padding-left: 12px;
        padding-right: 12px;
        margin-left: 5px;
        width: 10vw;
      }
    }
  }

  div.theory {
    textarea {
      width: 43vw;
      height: 90vh;
      margin-bottom: 10vh;
      resize: none;
      background-color: #222;
      border: 1px solid #222;
      padding-top: 30px;
      padding-left: 30px;
      font-size: 20px;
      color: #fff;
    }

    button.submit {
      position: absolute;
      bottom: 10vh;
      right: 12vh;
      background: #36ded6;
      border: 1px solid #333;
      border-radius: 5px;
      padding: 10px;
      padding-left: 12px;
      padding-right: 12px;
      width: 170px;
      font-weight: bold;
    }

    button.disabled {
      position: absolute;
      bottom: 10vh;
      right: 12vh;
      background: rgba(255, 100, 12, 0.8);
      border: 1px solid #333;
      border-radius: 5px;
      padding: 10px;
      padding-left: 12px;
      padding-right: 12px;
      width: 170px;
      font-weight: bold;
      font-size: 12px;
      color: #fff;
    }
  }

  div.code {
    width: 43vw;
    height: 90vh;
    margin-bottom: 10vh;
    button.submit {
      position: absolute;
      bottom: 10vh;
      right: 12vh;
      background: #36ded6;
      border: 1px solid #333;
      border-radius: 5px;
      padding: 10px;
      padding-left: 12px;
      padding-right: 12px;
      width: 170px;
      font-weight: bold;
    }

    button.disabled {
      position: absolute;
      bottom: 10vh;
      right: 12vh;
      background: rgba(255, 100, 12, 0.8);
      border: 1px solid #333;
      border-radius: 5px;
      padding: 10px;
      padding-left: 12px;
      padding-right: 12px;
      width: 170px;
      font-weight: bold;
      font-size: 12px;
      color: #fff;
    }
  }
`;

export const VideoModal = styled.div`
  position: absolute;
  width: 39vw;
  height: 60vh;
  background-color: #fff;
  border-top-left-radius: 20px;
  padding: 20px;

  button {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    margin-bottom: 30px;
  }
`;
export const ImageModal = styled.div`
  position: absolute;
  width: 40vw;
  height: 80vh;
  background-color: #fff;
  border-top-left-radius: 20px;
  padding: 20px;
  text-align: center;
  display: flex;
  flex: 1;
  flex-direction: column;

  button {
    cursor: pointer;
    align-self: flex-start;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    margin-bottom: 30px;
  }

  img {
    align-self: center;
    max-width: 25vw;
    max-height: 60vh;
  }
`;

export const ContainerFailed = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  button {
    background: rgba(0, 0, 0, 0);
    width: 150px;
    padding: 10px;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 600px;
  }
`;

export const Modal = styled.div`
  position: absolute;
  background-color: #fff;
  border-top-left-radius: 20px;
  padding: 20px;
  width: 35%;
  height: 60%;

  p {
    font-size: 16px;
    margin-bottom: 10px;
    margin-top: -10px;
  }

  button.icon {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    margin-bottom: 30px;
  }

  button.video {
    margin-top: 10px;
    height: 40px;
    width: 250px;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 12px;
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }
`;

export const ModalDone = styled.div`
  position: absolute;
  top: 20%;
  bottom: 20%;
  left: 18%;
  right: 20%;
  width: 60%;
  height: 60%;

  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  background-color: rgba(9, 15, 53, 0.95);
  border-radius: 10px;
  border: 3px solid #36ded6;
  padding: 20px;
  color: #fff;
  text-align: center;

  z-index: 10;

  button {
    height: 50px;
    width: 360px;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 14px;
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }

  div {
    p {
      font-size: 22px;
      line-height: 40px;
    }
  }

  p {
    font-size: 18px;
  }
`;

export const CloseModal = styled.div`
  position: absolute;
  width: 93%;
  height: 100vh;
  top: 0px;
  left: 95px;
  background: rgba(44, 51, 91, 0.6);
  border: none;
`;
